import { Box, Button, Modal, Typography } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '500px',
  bgcolor: 'background.paper',
  border: '2px solid #cecece',
  borderRadius: 2,
  boxShadow: 24,
  pt: 3,
  px: 4,
  pb: 3,
};

interface ConfirmGenerateResponseModalProps {
  open: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  actionType?: 'generate' | 'accept';
}

const ConfirmGenerateResponseModal = ({
  open,
  isLoading,
  onConfirm,
  onCancel,
  actionType = 'generate',
}: ConfirmGenerateResponseModalProps) => {
  const isAcceptAction = actionType === 'accept';
  const title = isAcceptAction ? 'Confirmação de Aceitação' : 'Confirmação de Geração Manual';
  const description = isAcceptAction
    ? 'Tem certeza de que deseja aceitar e enviar este depósito?'
    : 'Tem certeza de que deseja realizar a geração manual?';
  const successButtonText = isAcceptAction ? 'Sim, aceitar' : 'Sim, prosseguir';
  return (
    <Modal
      open={open}
      onClose={onCancel}
      aria-labelledby="confirm-modal-title"
      aria-describedby="confirm-modal-description"
    >
      <Box sx={{ ...style }}>
        <Typography
          id="confirm-modal-title"
          variant="h6"
          component="h2"
          sx={{ mb: 2, fontWeight: 'bold' }}
        >
          {title}
        </Typography>
        <Typography
          id="confirm-modal-description"
          sx={{ mb: 3, color: 'textSecondary' }}
        >
          {description}
        </Typography>
        {!isAcceptAction && (
          <Typography sx={{ mb: 2, fontSize: '0.95rem', fontStyle: 'italic' }}>
            Geração automática ocorrerá em breve.
          </Typography>
        )}
        {isAcceptAction && (
          <Typography sx={{ mb: 2, fontSize: '0.95rem', fontStyle: 'italic', color: 'info.main' }}>
            O arquivo CCS0004 será gerado e enviado automaticamente ao STA.
          </Typography>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2,
          }}
        >
          <Button
            variant="contained"
            color="error"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (isAcceptAction ? 'Aceitando...' : 'Gerando...') : successButtonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmGenerateResponseModal;
